export default __webpack_public_path__ + "static/media/slaapkamer1.cfb17b48.jpg";